import styled, { css } from 'styled-components';

import {
  IMarginProps,
  marginPropsStyles,
} from '~/shared/interfaces/IMarginProps';
import { TInputSize } from './types';

interface IInputWrapperProps {
  isTypePassword: boolean;
  hasIcon: boolean;
  hasError: boolean;
  size: TInputSize;
}

interface ICopyButtonProps {
  inputSize: TInputSize;
}

interface IPasswordButtonProps {
  inputSize: TInputSize;
}

export const Container = styled.label<IMarginProps>`
  ${marginPropsStyles}
`;

const getHeight: Record<TInputSize, string> = {
  lg: '48px',
  md: '42px',
  sm: '36px',
};

export const InputWrapper = styled.div<IInputWrapperProps>`
  display: flex;
  align-items: center;

  height: ${({ size }) => getHeight[size]};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.surface};
  border: ${({ theme }) => `1px solid ${theme.colors.gray[100]}`};

  transition: all ease-in 0.2s;
  overflow: hidden;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme, hasError }) =>
    hasError &&
    css`
      border-color: ${theme.colors.danger} !important;

      svg {
        color: ${theme.colors.danger} !important;
      }
    `}

  > input {
    background: none;
    position: relative;
    height: 100%;
    flex: 1;
    padding: ${({ theme, size }) =>
      `0 ${size === 'lg' ? theme.spacing.sm : '12px'}`};
    font-size: ${({ size }) => (size === 'sm' ? '12px' : '14px')};
    line-height: ${({ size }) => getHeight[size]};
    color: ${({ theme }) => theme.colors.onSurface};

    ${({ isTypePassword }) =>
      isTypePassword &&
      css`
        padding-right: 0;
      `}

    ${({ hasIcon }) =>
      hasIcon &&
      css`
        padding-left: 0;
      `}

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray[200]};
    }

    &:disabled {
      background-color: ${({ theme }) => theme.colors.gray[50]};
    }
  }

  > input[type='date']::-webkit-calendar-picker-indicator {
    height: auto;
    width: auto;
    position: absolute;

    background: transparent;
    color: transparent;

    cursor: pointer;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 48px;

  > svg {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;

export const EndContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  min-width: 48px;

  > svg {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;

export const CopyButton = styled.button.attrs({
  type: 'button',
})<ICopyButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: ${({ inputSize }) => getHeight[inputSize]};
  background: ${({ theme }) => theme.colors.background};

  > svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;

export const PasswordButton = styled.button.attrs({
  type: 'button',
})<IPasswordButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};

  height: 100%;
  width: ${({ inputSize }) => getHeight[inputSize]};

  > svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;
